import * as constants from '../constants';

const initialState = {};

export default function reducer(state = initialState, action) {
    switch (action.type) {
        case constants.getPurposesPhyto.success: {
            return action.payload;
        }

        case constants.getPurposesPhyto.error: {
            return initialState;
        }

        case constants.getPurposesPhyto.try: {
            return {};
        }

        default:
            return state;
    }
}